import * as React from 'react'
import { SVGProps } from 'react'
const SvgBag = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512 512" {...props}>
    <path d="M427.13 94.4h-65.6c-3.18-23.68-14.3-45.6-31.88-62.53C309.64 12.61 283.47 2 255.99 2c-27.49 0-53.66 10.59-73.67 29.83-17.6 16.91-28.74 38.85-31.96 62.57H83.72L52.1 510h407.8zM255.99 42.8c30.73 0 57.57 22.34 64.23 51.6H191.75c6.67-29.26 33.51-51.6 64.24-51.6zM96.48 469.2l25.47-334h27.43v68.5h40.8v-68.5h131.6v68.5h40.8v-68.5h28.53l25.47 334z" />
  </svg>
)
export default SvgBag
